import { IMetaSeasonAward } from '../../../store/admin/seasonAwards/store';

export const isAward = (item: any): item is IMetaSeasonAward =>
  (item as IMetaSeasonAward).position !== undefined;
